import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _taggedTemplateLiteral from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { keyframes } from 'styled-components';
var DotWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  text-align: center;\n"])));
var DotAnimation = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0%, 80%, 100% { \n    transform: scale(0);\n  } 40% { \n    transform: scale(1.0);\n  }\n"])));
var Dot = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 6px;\n  height: 6px;\n  background-color: ", ";\n  margin-right: 2px;\n  margin-left: 4px;\n  border-radius: 100%;\n  display: inline-block;\n  animation: ", " 1.4s infinite ease-in-out both;\n  animation-delay: ", ";\n"])), function (props) {
  return props.color;
}, DotAnimation, function (props) {
  return props.delay;
});
export function LoadingDot(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(DotWrapper, {
    children: [t('LOADING'), /*#__PURE__*/_jsx(Dot, {
      delay: "-0.32s",
      color: props.color
    }), /*#__PURE__*/_jsx(Dot, {
      delay: "-0.16s",
      color: props.color
    }), /*#__PURE__*/_jsx(Dot, {
      color: props.color
    })]
  });
}
LoadingDot.defaultProps = {
  color: '#ffffff'
};